angular.module('tgaAdmin').config(['stConfig',
  function (stConfig) {
    stConfig.sort.skipNatural = true;
    stConfig.sort.delay = 200;
    stConfig.pipe.delay = 210;
    stConfig.search.delay = 1000;
    stConfig.pagination.template = 'templates/partials/pagination.html';
    stConfig.pagination.number = 10; // Must match `st-items-by-page`
  },
]);
